import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-cy"]

import AgilaInfoBlock from "frontend-component-templates/src/components/agilaInfoBlock.vue";
import TableColumnHeadComponent from "../../components/sections/TableColumnHeadComponent.vue";
import { Product } from "../../classes/product";
import { ref } from "vue";
import { ProductGroup } from "../../classes/productGroup";

interface Props {
  product?: Product;
  selectedDate?: Date;
  liability: boolean;
  defaultProduct: number;
  productGroup: ProductGroup;
  sticky?: boolean;
  noHeaderVisible?: boolean;
  highlightDefaultProduct: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TableHeadComponent',
  props: {
    product: { default: undefined },
    selectedDate: { default: undefined },
    liability: { type: Boolean, default: false },
    defaultProduct: { default: undefined },
    productGroup: { default: undefined },
    sticky: { type: Boolean, default: true },
    noHeaderVisible: { type: Boolean, default: false },
    highlightDefaultProduct: { type: Boolean, default: false }
  },
  emits: ["selectProduct"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const noHeaderVisible = ref(false);

document.addEventListener("scroll", () => {
  const header = document
    .querySelector("#header > div")
    ?.shadowRoot?.querySelector("div > header");
  if (header) {
    const headerStyle = window.getComputedStyle(header);
    noHeaderVisible.value = headerStyle.display === "none";
  } else {
    noHeaderVisible.value = true;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["table-head", {
      sticky: props.sticky,
      'no-header': noHeaderVisible.value,
      'hps-combi': props.productGroup?.products?.length < 3,
      'single-product': props.productGroup?.products?.length === 1,
      liability: props.liability,
    }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["table-head-hint", { 'display-none': props.productGroup?.priceIsFinal() }])
    }, [
      _createVNode(AgilaInfoBlock, { small: true }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Ohne Rasse- und Altersangabe sehen Sie den Einstiegspreis")
        ])),
        _: 1,
        __: [0]
      })
    ], 2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.productGroup.products, (product, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["table-head-column", {
        'non-highlight-column':
          _ctx.highlightDefaultProduct &&
          props.defaultProduct !== 0 &&
          props.defaultProduct !== index + 1,
      }]),
        key: product.id,
        "data-cy": 'product-head-' + product.identifier
      }, [
        (props.defaultProduct === index + 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "table-head-column__recommendation desktop" }, " Unsere Empfehlung ", -1)),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "table-head-column__recommendation mobile" }, "Empfehlung", -1))
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(TableColumnHeadComponent, {
          product: product,
          selectedDate: props.selectedDate,
          liability: props.liability,
          defaultProduct: props.defaultProduct,
          index: index,
          onSelectProduct: ($event: any) => (emit('selectProduct', product))
        }, null, 8, ["product", "selectedDate", "liability", "defaultProduct", "index", "onSelectProduct"])
      ], 10, _hoisted_1))
    }), 128))
  ], 2))
}
}

})